import { render, staticRenderFns } from "./event-page-sample-donor-card.vue?vue&type=template&id=7b76a8a6&scoped=true&"
import script from "./event-page-sample-donor-card.vue?vue&type=script&lang=js&"
export * from "./event-page-sample-donor-card.vue?vue&type=script&lang=js&"
import style0 from "./event-page-sample-donor-card.vue?vue&type=style&index=0&id=7b76a8a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b76a8a6",
  null
  
)

export default component.exports